import React, { useState } from 'react';
import { getProductHistory } from '../../../api/configuracionSku';

const ListaProductos = ({
  productosPaginados,
  skusData,
  openMenus,
  toggleMenu,
  obtenerCompetenciasAsignadas,
  handleUnidadChange,
  handleCantidadChange,
  handlePrecioChange,
  handleMonedaChange,
  handleCompetenciaChange,
  handleCompetenciaCantidadChange,
  handleCompetenciaPrecioChange,
  addCompetencia,
  removeCompetencia,
  getOpcionesCompetenciasDisponibles,
  obtenerDatosCompetencia,
  productosModificados,
  guardarCambios,
  guardando,
  cargandoCompetencias
}) => {
  // Función para obtener el precio desde skusData (igual que obtenerDatosCompetencia)
  const obtenerPrecioDesdeSkusData = (productoId) => {
    if (!skusData || !productoId) return 0;
    
    const productoData = skusData.find(sku => sku.ID === productoId);
    
    if (productoData) {
      // Buscar el precio en diferentes formatos
      const precio = productoData.PRICE_DS || productoData.price_ds || productoData['PRICE_DS'] || 0;
      return precio;
    }
    
    return 0;
  };
  // Estado para controlar el modal de histórico
  const [modalHistorico, setModalHistorico] = useState({
    isOpen: false,
    producto: null,
    historial: [],
    cargando: false,
    error: null
  });

  // Función para abrir el modal de histórico
  const abrirModalHistorico = async (producto) => {
    console.log('🔍 Abriendo modal de histórico para producto:', producto);
    console.log('📝 ID del producto:', producto.id);
    
    // Validar que el producto tenga un ID válido
    if (!producto.id) {
      setModalHistorico({
        isOpen: true,
        producto: producto,
        historial: [],
        cargando: false,
        error: 'El producto no tiene un ID válido'
      });
      return;
    }

    // Abrir el modal con estado de carga
    setModalHistorico({
      isOpen: true,
      producto: producto,
      historial: [],
      cargando: true,
      error: null
    });

    try {
      // Hacer llamada a la API para obtener el historial real
      console.log('📡 Llamando a getProductHistory con ID:', producto.id);
      const response = await getProductHistory(producto.id);
      
      console.log('✅ Respuesta de la API:', response);
      console.log('📊 Datos completos:', response.data);
      console.log('📊 Array de historial:', response.data?.data);
      
      setModalHistorico({
        isOpen: true,
        producto: producto,
        historial: response.data?.data || [],
        cargando: false,
        error: null
      });
    } catch (error) {
      console.error('❌ Error al obtener el histórico:', error);
      console.error('📋 Detalles del error:', error.response?.data);
      
      setModalHistorico({
        isOpen: true,
        producto: producto,
        historial: [],
        cargando: false,
        error: `No se pudo cargar el histórico: ${error.response?.data?.message || error.message}`
      });
    }
  };

  // Función para cerrar el modal
  const cerrarModalHistorico = () => {
    setModalHistorico({
      isOpen: false,
      producto: null,
      historial: [],
      cargando: false,
      error: null
    });
  };
  if (cargandoCompetencias) {
    return (
      <div className="alert alert-info d-flex align-items-center mb-3" role="alert">
        <div className="spinner-border spinner-border-sm me-2" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <span>Cargando competencias asignadas...</span>
      </div>
    );
  }

  if (productosPaginados.length === 0) {
    return (
      <div className="no-productos-filtrados">
        <div className="text-center py-4">
          <i className="fas fa-search fa-2x text-muted mb-3" style={{color: '#F2A71C'}}></i>
          <h6 className="text-muted">No se encontraron productos</h6>
          <p className="text-muted mb-3">
            No hay productos que coincidan con los filtros aplicados
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="productos-lista">
        {productosPaginados.map((producto) => {
          // Log para verificar el precio de cada producto
          console.log(`🎯 Producto en ListaProductos - ${producto.id} (${producto.nombre}):`, {
            precio: producto.precio,
            tipoPrecio: typeof producto.precio,
            todasLasPropiedades: Object.keys(producto)
          });
          
          return (
        <div key={producto.id} className="producto-item">
          <div className="producto-input">
            <input 
              type="text" 
              value={producto.nombre}
              readOnly
              className="form-control"
            />
            <button 
              className="btn btn-sm btn-outline-info me-2"
              onClick={() => abrirModalHistorico(producto)}
              title="Ver histórico de modificaciones"
            >
              <i className="fas fa-history"></i>
              <span className="d-none d-md-inline ms-1">Ver histórico de precios</span>
            </button>
            <button 
              className={`menu-toggle ${openMenus[producto.id] ? 'active' : ''}`}
              onClick={() => toggleMenu(producto.id)}
              title={obtenerCompetenciasAsignadas(producto.id).length > 0 ? 
                `${obtenerCompetenciasAsignadas(producto.id).length} competencia(s) asignada(s)` : 
                'Sin competencias asignadas'
              }
            >
              <i className="fas fa-chevron-down"></i>
              {obtenerCompetenciasAsignadas(producto.id).length > 0 && (
                <span className="competencia-indicator" title="Tiene competencias asignadas">
                  <i className="fas fa-link"></i>
                </span>
              )}
            </button>
          </div>
          
          {openMenus[producto.id] && (
            <div className="menu-desplegable">
              <div className="menu-seccion izquierda">
                <h6>Datos</h6>
                <div className="datos-panel">
                  <div className="datos-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`unidad-${producto.id}`} className="form-label">
                        Unidad
                      </label>
                      <select 
                        id={`unidad-${producto.id}`}
                        className="form-select"
                        value={productosModificados[producto.id]?.unit ?? producto.unidad ?? "ml"}
                        onChange={(e) => handleUnidadChange(producto.id, e.target.value)}
                      >
                        <option value="ml">Mililitros (ml)</option>
                        <option value="g">Gramos (g)</option>
                        <option value="kg">Kilogramos (kg)</option>
                        <option value="l">Litros (l)</option>
                        <option value="un">Unidades (un)</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`cantidad-${producto.id}`} className="form-label">
                        Cantidad
                      </label>
                      <input
                        type="number"
                        id={`cantidad-${producto.id}`}
                        className="form-control"
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                        value={productosModificados[producto.id]?.qty !== undefined 
                          ? productosModificados[producto.id].qty 
                          : (producto.cantidad ?? "")}
                        onChange={(e) => handleCantidadChange(producto.id, e.target.value)}
                      />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`categoria-${producto.id}`} className="form-label">
                        Categoría
                      </label>
                      <input
                        type="text"
                        id={`categoria-${producto.id}`}
                        className="form-control"
                        defaultValue={producto.categoria || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`marca-${producto.id}`} className="form-label">
                        Marca
                      </label>
                      <input
                        type="text"
                        id={`marca-${producto.id}`}
                        className="form-control"
                        defaultValue={producto.marca || ""}
                        readOnly
                      />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`precio-${producto.id}`} className="form-label">
                        Precio
                      </label>
                      <input
                        type="number"
                        id={`precio-${producto.id}`}
                        className="form-control"
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                        value={productosModificados[producto.id]?.precio !== undefined 
                          ? productosModificados[producto.id].precio 
                          : (obtenerPrecioDesdeSkusData(producto.id) || producto.precio || "")
                        }
                        onChange={(e) => handlePrecioChange && handlePrecioChange(producto.id, e.target.value)}
                      />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
                      <label htmlFor={`moneda-${producto.id}`} className="form-label">
                        Moneda
                      </label>
                      <select 
                        id={`moneda-${producto.id}`}
                        className="form-select"
                        value={productosModificados[producto.id]?.moneda ?? producto.moneda ?? "Dólares"}
                        onChange={(e) => handleMonedaChange && handleMonedaChange(producto.id, e.target.value)}
                      >
                        {/* <option value="Bolívares">Bolívares</option> */}
                        <option value="Dólares">Dólares</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="menu-seccion derecha">
                <h6>Competencias</h6>
                <div className="competencias-panel">
                  {producto.competencias ? producto.competencias.map((competencia, index) => {
                    const opcionesDisponibles = getOpcionesCompetenciasDisponibles(producto.id, index);
                    
                    // Obtener datos completos de la competencia desde la tabla products
                    const datosCompetencia = obtenerDatosCompetencia(competencia.sku);
                    
                    // Obtener la unidad actual del producto (del estado modificado o del original)
                    const unidadActual = productosModificados[producto.id]?.unit || producto.unidad || "ml";
                    const unidadTexto = {
                      "ml": "Mililitros (ml)",
                      "g": "Gramos (g)", 
                      "kg": "Kilogramos (kg)",
                      "l": "Litros (l)",
                      "un": "Unidades (un)"
                    }[unidadActual] || "Mililitros (ml)";
                    
                    // Obtener la moneda actual del producto
                    const monedaActual = productosModificados[producto.id]?.moneda || producto.moneda || "Dólares";
                    const simboloMoneda = monedaActual === "Dólares" ? "$" : "Bs";
                    
                    // Usar el valor actual de la competencia (que puede haber sido editado por el usuario)
                    // Si no hay valor editado, usar el QTY de la tabla products como fallback
                    const cantidadMostrar = competencia.cantidad !== null && competencia.cantidad !== undefined 
                      ? competencia.cantidad 
                      : (datosCompetencia?.cantidad !== null && datosCompetencia?.cantidad !== undefined 
                        ? datosCompetencia.cantidad 
                        : "");
                    
                    const precioMostrar = competencia.precio !== null && competencia.precio !== undefined 
                      ? competencia.precio 
                      : (datosCompetencia?.precio !== null && datosCompetencia?.precio !== undefined 
                        ? datosCompetencia.precio 
                        : "");
                    
                    // Debug: mostrar valores de competencia
                    console.log('📊 Competencia en ListaProductos:', {
                      productoId: producto.id,
                      competenciaIndex: index,
                      competencia: competencia,
                      datosCompetencia: datosCompetencia,
                      cantidadOriginal: competencia.cantidad,
                      cantidadMostrar: cantidadMostrar,
                      cantidadType: typeof cantidadMostrar,
                      precioMostrar: precioMostrar,
                      monedaActual: monedaActual
                    });
                    
                    return (
                    <div key={index} className="competencia-item">
                      <div className="competencia-selector-container">
                        <div className="competencia-select-wrapper">
                          <select 
                            className="form-select"
                            value={competencia.sku || ""}
                            onChange={(e) => handleCompetenciaChange(producto.id, index, e.target.value, opcionesDisponibles)}
                          >
                            <option value="">Seleccionar competencia</option>
                            {opcionesDisponibles.map(opcion => (
                              <option key={opcion.value} value={opcion.value}>
                                {opcion.label} {opcion.marca ? `- ${opcion.marca}` : ''} {opcion.categoria ? `(${opcion.categoria})` : ''}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="competencia-input-group">
                          <label className="competencia-label">
                            {unidadTexto}
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            title="Cantidad de la competencia"
                            value={cantidadMostrar}
                            onChange={(e) => handleCompetenciaCantidadChange && handleCompetenciaCantidadChange(producto.id, index, e.target.value)}
                          />
                        </div>
                        <div className="competencia-input-group">
                          <label className="competencia-label">
                            Precio ({simboloMoneda})
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            title="Precio de la competencia"
                            value={precioMostrar}
                            onChange={(e) => handleCompetenciaPrecioChange && handleCompetenciaPrecioChange(producto.id, index, e.target.value)}
                          />
                        </div>
                      </div>
                      <button 
                        className="btn-remove-competencia"
                        onClick={() => removeCompetencia(producto.id, index)}
                        title="¿Eliminar competencia? Se guardará al presionar 'Guardar'"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </div>
                    );
                  }) : null}
                  
                  <button 
                    className="btn-add-competencia"
                    onClick={() => addCompetencia(producto.id)}
                    title="Agregar competencia"
                  >
                    <i className="fas fa-plus"></i>
                    Agregar Competencia
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {/* Botón de guardar debajo del acordeón abierto */}
          {openMenus[producto.id] && (
            <div className="acordeon-save-section">
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={guardarCambios}
                  disabled={guardando}
                  title="Guardar configuración de este producto"
                >
                  {guardando ? (
                    <>
                      <div className="spinner-border spinner-border-sm me-1" role="status">
                        <span className="visually-hidden">Guardando...</span>
                      </div>
                      <span className="d-none d-sm-inline">Guardando...</span>
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-1"></i>
                      <span className="d-none d-sm-inline">Guardar</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
          );
        })}
      </div>

      {/* Modal de Histórico */}
      {modalHistorico.isOpen && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={cerrarModalHistorico}>
          <div className="modal-dialog modal-xl modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-history me-2"></i>
                  {modalHistorico.producto?.nombre}
                </h5>
                <button type="button" className="btn-close" onClick={cerrarModalHistorico}></button>
              </div>
              <div className="modal-body">
                {modalHistorico.cargando ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3 text-muted">Cargando histórico...</p>
                  </div>
                ) : (
                  <>
                    {modalHistorico.error && (
                      <div className="alert alert-warning mb-3" role="alert">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {modalHistorico.error}
                      </div>
                    )}
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">Fecha Inicio</th>
                            <th scope="col">Fecha Fin</th>
                            <th scope="col">Precio DS</th>
                            <th scope="col">Tasa</th>
                            <th scope="col">Usuario Inserción</th>
                            <th scope="col">Usuario Actualización</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalHistorico.historial.length > 0 ? (
                            modalHistorico.historial.map((registro, index) => {
                              // Formatear fechas
                              const formatearFecha = (fecha) => {
                                if (!fecha) return '-';
                                const date = new Date(fecha);
                                return date.toLocaleString('es-VE', {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  second: '2-digit'
                                });
                              };

                              return (
                                <tr key={registro.id || index}>
                                  <td>{formatearFecha(registro.liveStartDate)}</td>
                                  <td>{formatearFecha(registro.liveEndDate)}</td>
                                  <td>${parseFloat(registro.priceDs || 0).toFixed(2)}</td>
                                  <td>{registro.rate || '0'}</td>
                                  <td>{registro.userUidInsert || '-'}</td>
                                  <td>{registro.userUidUpdated || '-'}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2 d-block"></i>
                                No se encontró historial de precios para este producto
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={cerrarModalHistorico}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListaProductos;
